import React from "react";
import { withRouter } from "react-router-dom";
import classnames from "classnames";
import { getUrl, Constants, Analytics } from "../../utilities";
import LiveSubMenuCard from "./LiveSubMenuCard";
import "./LiveSubMenuTab.scss";
import { liveChannelNames } from "../../constants";
const LiveSubMenuTab: React.FunctionComponent<any> = ({ navItem, location, history, handleLiveClick, props }) => {
  const className = classnames("TvGuideButton", {selected: location.pathname.includes(Constants.TvGuideTarget)});

  const onClick = () => {
    // Track navigation click for TV Guide
    const target = `live/guide/${Constants.TvGuidePaths[0]}`;
    const sectionName = `live::guide::${Constants.TvGuidePaths[0]}`;

    Analytics.userActionNavigation("TV Guide", getUrl(target), {
      context: "tv_guide",
      sectionName: sectionName
    });

    props.appBodyClassName(undefined);
    history.push(getUrl(target))
  }

  const sortedNavChildren = navItem.children && navItem.children.sort(  (a, b) => liveChannelNames.indexOf(a.title) - liveChannelNames.indexOf(b.title));
  return (
    <div className="LiveSubMenuTab">
      <div className="LiveSubMenu">
        { sortedNavChildren && sortedNavChildren.map((item, index) =>
          <LiveSubMenuCard props={props} handleLiveClick={handleLiveClick} key={index} index={index} item={item}></LiveSubMenuCard>
        ) }
      </div>
      <button className={className} onClick={onClick}>TV Guide</button>
    </div>
  )
};

export default withRouter(LiveSubMenuTab);
